module.exports = __webpack_public_path__ + "static/information-1a109c9ef03c11b86d691ae97ba09401.png";